/* @flow */
import ConfirmDialog from 'components/ConfirmDialog.jsx';
import Group from 'entities/Group';
import GroupActions from 'groups/actions/GroupActions';
import GroupMembershipStore from 'stores/GroupMembershipStore';
import GroupName from 'groups/components/GroupName.jsx';
import React from 'react';
import ToastActions from 'actions/ToastActions';

class GroupLeaveConfirmDialog extends React.Component {
  static propTypes = {
    group: React.PropTypes.instanceOf(Group).isRequired,
    onLeave: React.PropTypes.func,
  };

  static contextTypes = {
    router: React.PropTypes.object.isRequired,
  };

  unsubscribe = () => {
    const { group } = this.props;

    if (this.props.onLeave) {
      this.props.onLeave();
    }

    GroupActions.unsubscribeFromGroup(group).then(() => {
      GroupMembershipStore.removeGroupMembershipsForGroup(group.id);
      this.context.router.push('/classes');
      ToastActions.showSuccessToast(`You have left ${group.getName()}`);
    }).catch(e => console.error('GroupLeaveConfirmDialog unsubscribeFromGroup failed', e));
  };

  render() {
    const { group } = this.props;

    const subtext = (
      <span>
        Once you leave, you will no longer receive messages from{' '}
        <GroupName group={group} />
      </span>
    );

    return (
      <ConfirmDialog
        eventScreenName="GroupLeaveConfirmDialog"
        {...this.props}
        actionButtonText="Leave"
        cancelButtonText="Cancel"
        size="xsmall"
        onConfirm={this.unsubscribe}
        title="Leave this class?"
        subtext={subtext}
      />
    );
  }
}

export default GroupLeaveConfirmDialog;



// WEBPACK FOOTER //
// ./src/groups/components/GroupLeaveConfirmDialog.jsx